import Layout from '../../components/Layout'

export default function Inbox() {
  return (
    <Layout>
      <div className="max-w-screen-2xl mx-auto px-6 py-6">
        <h1 className="text-2xl font-semibold text-text-primary mb-6">Inbox</h1>
        <div className="bg-white rounded-lg border border-gray-200 p-12 text-center">
          <div className="text-text-muted mb-2">
            <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
            </svg>
          </div>
          <p className="text-text-secondary font-medium">Inbox coming soon</p>
          <p className="text-sm text-text-muted mt-1">Your notifications and messages will appear here.</p>
        </div>
      </div>
    </Layout>
  )
}
